module.exports = __webpack_public_path__ + "static/img/invite_activity_demo.eaaabfc5.png";